module.exports = require('./helpers/bundle-url').getBundleURL('lbB2N') + "right_arrow_black.0f9265df.svg";